<kiwi-decision-content *ngIf="decision" class="financialContent cell-block-y">
    <table class="_tableColor">
        <tbody>
            <tr class="_titlePartTable">
                <td></td>
                <td class="_number"[i18nKey]="'common.studies.amount'"></td>
            </tr>
            <tr *ngFor="let productOrCharge of decision | keys">
                <td>
                    {{'decisions.financial.' + productOrCharge | translate}}
                </td>
                <td>
                    <kiwi-currency-input
                        [(ngModel)]="decision[productOrCharge]"
                        (change)="onValueUpdate()"
                        [disabled]="decisionsReadonly"
                        [name]="productOrCharge">
                    </kiwi-currency-input>
                </td>
            </tr>
        </tbody>
    </table>
</kiwi-decision-content>
